$(function() {
  const fixcart = $(".fixed_cart");
  if (fixcart.length) {
    fixcart.hide();
    var windowWidth = $(window).width();
    if (windowWidth < 768) {
      $(window).on('scroll', function() {
        if ($(this).scrollTop() > 1800) {
          fixcart.fadeIn();
        } else {
          fixcart.fadeOut();
        }
      });
    } else {
      $(window).on('scroll', function() {
        if ($(this).scrollTop() > 2000) {
          fixcart.fadeIn();
        } else {
          fixcart.fadeOut();
        }
      });
    }
    return false;
  }
});